import React from 'react';
import { Pencil, Trash2 } from 'lucide-react';
import TradingRulesList from './TradingRulesList';

const PlaybookDetail = ({ playbook, rules, onEditPlaybook, onDeletePlaybook, onAddRule, onEditRule, onToggleRule, onDeleteRule }) => {
  if (!playbook) return null;

  return (
    <div className="bg-card text-card-foreground rounded-lg shadow-sm border border-border p-4">
      {/* Playbook Header */}
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="text-base font-semibold text-foreground">{playbook.name}</h3>
          {playbook.description && (
            <p className="text-xs text-muted-foreground mt-0.5">{playbook.description}</p>
          )}
        </div>
        <div className="flex items-center gap-1">
          <button
            onClick={onEditPlaybook}
            className="p-1.5 text-muted-foreground hover:text-foreground transition-colors rounded-md hover:bg-muted"
            title="Edit playbook"
          >
            <Pencil className="w-3.5 h-3.5" />
          </button>
          <button
            onClick={onDeletePlaybook}
            className="p-1.5 text-muted-foreground hover:text-red-500 transition-colors rounded-md hover:bg-muted"
            title="Delete playbook"
          >
            <Trash2 className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>

      {/* Rules */}
      <TradingRulesList
        rules={rules}
        onAddRule={onAddRule}
        onEditRule={onEditRule}
        onToggleRule={onToggleRule}
        onDeleteRule={onDeleteRule}
      />
    </div>
  );
};

export default PlaybookDetail;
